import React from "react";

const NavbarGhost = () => {
  return (
    <div className="navbar-ghost-wrapper">
      {/* We leave this empty for now as requested. 
          The CSS will handle the solid bar feel.
      */}
    </div>
  );
};

export default NavbarGhost;
